import { useEffect, useRef, useState } from 'react';
function log(text) {
    void text;
}
export function useScanner(options = {}) {
    const [code, setCode] = useState(null);
    const scannedDataRef = useRef('');
    const isScanningRef = useRef(false);
    const prefixMatchRef = useRef('');
    const optionsRef = useRef({
        element: document.body,
        ...(options ?? {})
    });
    const prefix = '';
    const confirmKeys = ['Enter', 'Tab', 'F14'];
    const confirmCode = (scannedData) => {
        scannedData = scannedData.replace(/[^0-9a-zA-Z ]/g, '');
        const finalCode = translateKeys(scannedData);
        log('FinalCode:' + finalCode + '\n');
        setCode(finalCode);
        scannedDataRef.current = '';
        isScanningRef.current = false;
    };
    const keyDownListener = (event) => {
        const activeElement = document.activeElement;
        const isFormLikeElementFocused = (() => {
            if (!activeElement) {
                return false;
            }
            const tagName = activeElement.tagName;
            const isContentEditable = activeElement.isContentEditable;
            if (isContentEditable) {
                return true;
            }
            if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') {
                return true;
            }
            return false;
        })();
        let key = event.key;
        log('Key:' + key + '\n');
        if (isFormLikeElementFocused || key == 'Shift' || key == 'Unidentified') {
            if (isFormLikeElementFocused && isScanningRef.current) {
                // Cancel ongoing scanning when user focuses a native form control
                scannedDataRef.current = '';
                isScanningRef.current = false;
                prefixMatchRef.current = '';
            }
            return;
        }
        if (key == 'Alt' || key == 'Meta' || key == 'Control' || key == 'Shift') {
            return;
        }
        log('IsScanning:' + isScanningRef.current + '\n');
        if (isScanningRef.current) {
            if (confirmKeys.includes(key)) {
                log('ConfirmKeys:' + confirmKeys.includes(key) + '\n');
                confirmCode(scannedDataRef.current);
            }
            else {
                scannedDataRef.current += key;
            }
        }
        else {
            if (prefix == '') {
                isScanningRef.current = true;
                scannedDataRef.current = key;
            }
            else if (prefixMatchRef.current + key === prefix) {
                isScanningRef.current = true;
                prefixMatchRef.current = '';
                scannedDataRef.current = '';
            }
            else if (prefix.startsWith(prefixMatchRef.current + key) == false) {
                prefixMatchRef.current = '';
            }
            else {
                prefixMatchRef.current += key;
            }
        }
    };
    const start = () => {
        optionsRef.current.element?.addEventListener('keydown', keyDownListener);
        window.debugScanner = (code) => {
            confirmCode(code);
        };
    };
    const stop = () => {
        optionsRef.current.element?.removeEventListener('keydown', keyDownListener);
        delete window.debugScanner;
    };
    useEffect(() => {
        start();
        return () => stop();
    }, []);
    return {
        start,
        stop,
        code
    };
}
function translateKeys(text) {
    const keyMap = {
        '+': '1',
        ě: '2',
        š: '3',
        č: '4',
        ř: '5',
        ž: '6',
        ý: '7',
        á: '8',
        í: '9',
        é: '0'
    };
    return text
        .split('')
        .map(char => keyMap[char] ?? char)
        .join('');
}
//# sourceMappingURL=use-scanner.js.map